/**
 * GENERATED CODE - DO NOT MODIFY
 */
import { type HeadersMap, XRPCError } from '@atproto/xrpc'
import { type ValidationResult, BlobRef } from '@atproto/lexicon'
import { CID } from 'multiformats/cid'
import { validate as _validate } from '../../../../lexicons.js'
import {
  type $Typed,
  is$typed as _is$typed,
  type OmitKey,
} from '../../../../util.js'
import type * as AppBskyAgeassuranceDefs from './defs.js'

const is$typed = _is$typed,
  validate = _validate
const id = 'app.bsky.ageassurance.getState'

export type QueryParams = {
  countryCode: string
  regionCode?: string
}
export type InputSchema = undefined

export interface OutputSchema {
  state: AppBskyAgeassuranceDefs.State
  metadata: AppBskyAgeassuranceDefs.StateMetadata
}

export interface CallOptions {
  signal?: AbortSignal
  headers?: HeadersMap
}

export interface Response {
  success: boolean
  headers: HeadersMap
  data: OutputSchema
}

export function toKnownErr(e: any) {
  return e
}
